module.exports = __webpack_public_path__ + "static/media/activation-functions.5c232fa1.gif";